module.exports = __webpack_public_path__ + "static/img/manual_zh_11.b0fcc35.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_11.png
// module id = kDfk
// module chunks = 4